import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Breadcrumbs, { breadcrumbsClasses } from "@mui/material/Breadcrumbs";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import { Link, useLocation } from "react-router-dom";
import { toTitleCase } from "../helpers";
import { useAuth } from "../auth/identity-auth0-context";

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: "center",
  },
}));

const NavbarBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, userRoles, hasClientId, isLoading } = useAuth();

  if (
    !isAuthenticated ||
    !Array.isArray(userRoles) ||
    userRoles.length === 0 ||
    !hasClientId ||
    isLoading
  ) {
    return null;
  }

  const pathSegments = location.pathname.split("/").filter(Boolean);

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      <Typography
        key="home"
        component={Link}
        to="/"
        variant="body1"
        sx={{
          textDecoration: "none",
          color: "text.secondary",
          fontWeight: 500,
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        Dtection
      </Typography>

      {pathSegments.map((segment, index) => {
        const to = `/${pathSegments.slice(0, index + 1).join("/")}`;
        const isLast = index === pathSegments.length - 1;

        return isLast ? (
          <Typography
            key={segment}
            variant="body1"
            sx={{ fontWeight: 600, color: "text.primary" }}
          >
            {toTitleCase(segment.replace("-", " "))}
          </Typography>
        ) : (
          <Typography
            key={segment}
            component={Link}
            to={to}
            variant="body1"
            sx={{
              textDecoration: "none",
              color: "text.secondary",
              fontWeight: 400,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {toTitleCase(segment.replace("-", " "))}
          </Typography>
        );
      })}
    </StyledBreadcrumbs>
  );
};

export default NavbarBreadcrumbs;
